import BaseDataObject from './BaseDataObject';
import Money from './Money';

export default class RowsLeftInformation extends BaseDataObject {
  getNumberOfRows() {
    return this.getNumberOf('rows');
  }

  getRow(legNr) {
    for (let n = 0; n < this.getNumberOfRows(); n++) {
      const row = this.getObject('rows', RowsLeftRow, n);

      if (row.getLegNr() === legNr) {
        return row;
      }
    }
    return null;
  }

  getChanceOfCorrect(index) {
    return this.getObject('chanceOfCorrects', ChanceOfCorrect, index);
  }

  getPreliminaryDividendPerHorse() {
    return this.getObjects('preliminaryDividendPerHorse', Money);
  }
}

class ChanceOfCorrect extends BaseDataObject {
  getColor() {
    return this.getString('color');
  }

  getNrOfCorrectStillPossible() {
    return this.getInteger('nrOfCorrectStillPossible');
  }
}

class RowsLeftRow extends BaseDataObject {
  isEmpty() {
    return this.getNumberOf('rowsLeft') === 0;
  }

  getLegNr() {
    return this.getInteger('legNr');
  }

  getColor() {
    return this.getString('showColor');
  }

  getRowsLeft(index) {
    return this.getFloatAt('rowsLeft', index);
  }

  getPercentLeft(index) {
    return this.getFloatAt('percentLeft', index);
  }

  getRowsLeftForLeg(legIndex) {
    const rowsLeftPerLeg = this.getArray('rowsLeftPerLeg');
    return rowsLeftPerLeg[legIndex];
  }

  getPercentLeftForLeg(legIndex) {
    const percentLeftPerLeg = this.getArray('percentLeftPerLeg');
    return percentLeftPerLeg[legIndex];
  }
}
